import themeStyles from './style.module.scss';
export const fontSizes = {
    sm: 0.6,
    md: 0.8,
    lg: 1,
    xl: 1.3,
};
export const isFontSize = (value) => {
    return value in fontSizes;
};
export const isValidColor = (color) => {
    return CSS.supports('color', color);
};
export const getDefaultTextColor = (theme) => {
    return theme === 'dark' ? themeStyles.darkFgColor : themeStyles.defaultFgColor;
};
export const getDefaultBgColor = (theme) => {
    return theme === 'dark' ? themeStyles.darkBgColor : themeStyles.defaultBgColor;
};
const isSubtitlesTheme = (value) => {
    return value === 'dark' || value === 'light';
};
const parseTheme = (value) => {
    return isSubtitlesTheme(value) ? value : 'dark';
};
const parseFontSize = (value) => {
    return isFontSize(value) ? value : 'lg';
};
const parseColor = (urlParams, paramKey, fallback) => {
    const value = urlParams.get(paramKey);
    if (value === null) {
        return fallback;
    }
    const needsHashPrefix = value !== "transparent" && !value.startsWith('#');
    const color = needsHashPrefix ? `#${value}` : value;
    return isValidColor(color) ? color : fallback;
};
const isTextAlign = (value) => value === 'top' || value === 'bottom';
export const loadSubtitlesSettings = (customValues = {}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const controls = (urlParams.get('controls') ?? 'auto');
    const themeParam = urlParams.get('theme');
    const theme = parseTheme(themeParam === null ? localStorage.getItem('subtitlesTheme') : themeParam);
    const fontSizeParam = urlParams.get('fontSize');
    const fontSize = parseFontSize(fontSizeParam === null ? localStorage.getItem('subtitlesFontSize') : fontSizeParam);
    const textColor = parseColor(urlParams, 'textColor', getDefaultTextColor(theme));
    const bgColor = parseColor(urlParams, 'bgColor', getDefaultBgColor(theme));
    const textAlignParam = urlParams.get('textAlign');
    const textAlign = isTextAlign(textAlignParam) ? textAlignParam : 'top';
    return {
        controls: controls,
        theme,
        fullscreen: false,
        fontSize,
        textColor,
        bgColor,
        textAlign,
        customCss: '',
        ...customValues,
    };
};
export const storeSubtitlesSettings = (settings) => {
    localStorage.setItem('subtitlesTheme', settings.theme);
    localStorage.setItem('subtitlesFontSize', settings.fontSize);
};
